export function getIsCookiesEnabled(): boolean {
  return true;
  // return store.getState().settings.isCookiesEnabled;
}
